<template>
<div>
    <h4>
        <b-icon v-if="status == 'ONLINE'" icon="check-square-fill" scale='1' variant="success" :title="$t('infopoints.states.ONLINE')"></b-icon>
        <b-icon v-if="status == 'OFFLINE-1'" icon="exclamation-square-fill" scale='1' variant="warning" :title="$t('infopoints.states.OFFLINE-1')"></b-icon>
        <b-icon v-if="status == 'OFFLINE-2'" icon="dash-square-fill" scale='1' variant="danger" :title="$t('infopoints.states.OFFLINE-2')"></b-icon>
        <b-icon v-if="status == 'UNKNOWN'" icon="question-square-fill" scale='1' variant="secondary" :title="$t('infopoints.states.UNKNOWN')"></b-icon>
        <span>{{ label }}</span>
        <a @click="closeDisplayDetails" href="#" class="action-link"  v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.8"></b-icon></a>
    </h4>
   
    <!--
    <div v-for="infopoint in display.infopoints" :key="'ip-'+ infopoint.infopointId" class="screenshot">
        <img :src="infopoint.screenshot" :alt="infopoint.infopointLabel" />
        <header>{{ $t('terminals.display_status') + ': ' + formatTimestamp(infopoint.statusTimestamp) }}</header>
    </div>
    -->

    <div class="attr-table">
        <b-row><b-col cols="4">{{ $t('terminals.device.name') }}</b-col><b-col>{{ display.name }}</b-col></b-row>
         <b-row><b-col cols="4">{{ $t('terminals.device.timetable') }}</b-col><b-col>{{ timetableView.id }}</b-col></b-row>
        <template v-if="infopoint">
            <b-row><b-col cols="4">{{ $t('terminals.device.id') }}</b-col><b-col>{{ infopoint.infopointLabel }}</b-col></b-row>
            <b-row><b-col cols="4">{{ $t('terminals.device.statustime') }}</b-col><b-col>{{ formatTimestamp(infopoint.statusTimestamp) }}</b-col></b-row>
            <b-row><b-col cols="4">{{ $t('terminals.device.status') }}</b-col><b-col>{{ $t('infopoints.states.' + status) }}</b-col></b-row>
        </template>
    </div>

    <div v-if="infopoint">
    
    </div>
    
    <div v-for="infopoint in display.infopoints" :key="'ip-'+ infopoint.infopointId +'-'+ infopoint.screenshotTime">
        <TerminalDisplayScreenshot :item="infopoint"></TerminalDisplayScreenshot>
    </div>
    
    <h4 class='mt-5'><b-icon icon="clock"></b-icon>{{ $t('terminals.next_departures') }}</h4>
    <TimetableViewDepartures :item="timetableView" count="10" />

    <TerminalDisplayAnnouncements :terminalId="terminalId" />
  
</div>
</template>

<script>
import TerminalDisplayAnnouncements from '@/components/Terminals/TerminalDisplayAnnouncements';
//import TimetableViewDepartures from '@/components/Content/Timetables/TimetableViewDepartures';
import TimetableViewDepartures from '@/components/Content/Timetables/TimetableViewDeparturesCompact';

import terminalView from '@/store/terminals/terminalView';
import moment from 'moment';

import TerminalDisplayScreenshot from '@/components/Terminals/TerminalDisplayScreenshot';

export default {
	name: 'TerminalDisplayDetails',
    props: ['terminalId', 'activeTerminalId'],
    components : {
        TerminalDisplayAnnouncements, 
        // eslint-disable-next-line vue/no-unused-components
        TimetableViewDepartures,
        TerminalDisplayScreenshot
    },
    
    data() {
        return {
            updateView: 0
        };
    },
    computed: {
        display() {
            if (this.$store.state.terminalView.selectedDisplay &&
                this.$store.state.terminalView.selectedDisplay.displayId) {
                return this.$store.state.terminalView.selectedDisplay;
            }
            return { infopoints: [] };
        },
        timetableView(){
            return { id: this.display.displayId };

        },
        infopoint(){
            // voiko olla useita?
            return this.display.infopoints.length > 0 ? this.display.infopoints[0] : null;
        },
        status(){
            var status = 'UNKNOWN';
            if (this.infopoint && this.infopoint.statusTimestamp) {
                var now = new Date();
                var sd = Date.parse(this.infopoint.statusTimestamp);

                var diff = now - sd;
                var limit1 = 1000 * 60 * 60;    // 1 h
                var limit2 = limit1 * 12 ;      // 12 h

                if (diff < limit1) status = "ONLINE";
                if (diff > limit1) status = "OFFLINE-1";
                if (diff > limit2) status = "OFFLINE-2";
            }
            return status;
        },
        label(){
            var label = this.display.displayId;
        
            if(this.display.presentationType == 'platformdisplay' || this.display.presentationType == 'driverdisplay') label = this.display.platform;
            if(this.display.shortName && this.display.shortName.length > 0) label = this.display.shortName;
                      
            return label;
        }
    },
    methods: {
        formatTimestamp(timestamp) {
            var ts = "-";
            if(timestamp) ts = new moment(timestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
            return ts;
        },
        closeDisplayDetails() {
            this.$store.commit('terminalView/setSelectedDisplay', {});
        },
        update(){
            clearTimeout(this.updater);
            this.updateView++;
            this.updater = setTimeout(this.update, 5000);   
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }

        this.update();
    }
}
</script>
